import {
    SuperBit_swaggerClient,
    RoleModel,
    RoleUpsertModel,
    SortModel,
} from './superbit-api-models';
import generalSettings from '../json/general-settings.json';

// Service wrapper for the System Management "Groups" tab.
// Mirrors the data the old MVC _Groups.cshtml view rendered (maintenance/groupSort)
// and the add/edit group form (_NewGroup.cshtml -> maintenance/groupGet + groupCreate).
export class GroupsModel {
    client: any;

    constructor() {
        const apiUrl = localStorage.getItem('apiUrl');
        const url = apiUrl ? apiUrl : generalSettings.apiUrl;

        // Some generated client methods omit the Authorization header; inject it
        // here (only when absent) so every call through this client is authenticated.
        const authHttp = {
            fetch(input: RequestInfo, init?: RequestInit) {
                const token = localStorage.getItem('AuthToken');
                const headers: any = { ...(init && init.headers ? init.headers : {}) };
                if (token && !headers['Authorization']) {
                    headers['Authorization'] = `Bearer ${token}`;
                }
                return window.fetch(input, { ...(init || {}), headers });
            },
        };

        this.client = new SuperBit_swaggerClient(url, authHttp);
    }

    // Sorted groups (roles) list — replaces _Groups.cshtml + _GroupsItems.cshtml.
    // Pass an empty array for the default (unsorted) order, exactly like the old view.
    async groupSort(sortBy: SortModel[]): Promise<RoleModel[]> {
        const result = await this.client.groupSort(sortBy);
        return result ? result : [];
    }

    // Loads the create/edit form model. No id (add mode) returns a fresh model with
    // the full module-permission list; an id (edit mode) fills the group's values.
    async groupGet(id?: string): Promise<RoleUpsertModel> {
        return await this.client.groupGet(id);
    }

    // Create AND edit both post through groupCreate (the server upserts by Id),
    // mirroring the old MVC _NewGroup form which always posted to Group/Create.
    async groupCreate(model: RoleUpsertModel): Promise<void> {
        return await this.client.groupCreate(model);
    }

    async groupDelete(id: string): Promise<void> {
        return await this.client.groupDelete(id);
    }
}
